import { twMerge } from "tailwind-merge";

import { CancelSubmitButtons } from "~/common/components";
import Modal from "~/common/components/Modal";

interface SessionSoapNoteConfirmationModalProps {
  isPending: boolean;
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const SessionSoapNoteConfirmationModal = ({
  isPending,
  show,
  onClose,
  onSubmit,
}: SessionSoapNoteConfirmationModalProps) => (
  <Modal
    show={show}
    title="Complete SOAP note"
    description="Are you sure you want to complete the SOAP note? Once completed, you won't be able to make further changes."
    onClose={onClose}
  >
    <CancelSubmitButtons
      cancelClassName="w-fit"
      submitClassName={twMerge("w-fit", isPending && "w-60 justify-center")}
      containerClassName="w-fit self-end"
      submitButtonLabel="Complete SOAP note"
      submitButtonType="button"
      handleCancel={onClose}
      isSubmitting={isPending}
      handleSubmit={onSubmit}
    />
  </Modal>
);
